"use strict";
import { Svg } from "react-native-svg";
import { createIcon } from "../factories/createIcon";
export const [VoteIcon, AnimatedVoteIcon] = createIcon({
  name: "WalletFilled",
  getIcon: (props) => <Svg fill="none" viewBox="0 0 24 24" {...props}>
      <path
    fill="currentColor"
    d="M10.95 13.35L15.9 8.4l-1.425-1.425L10.95 10.5l-1.4-1.4l-1.425 1.425zM12 22q-4.025-3.425-6.012-6.362T4 10.2q0-3.75 2.413-5.975T12 2t5.588 2.225T20 10.2q0 2.5-1.987 5.438T12 22"
  />
    </Svg>
});
